var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-media"},[(_vm.data.mediaType === 1)?_c('img',{attrs:{"src":_vm.data.mediaUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }